var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExperiment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#experiment_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.488 2.516h.764V4.95c0 .284-.075.563-.219.81l-3.847 6.598a2.703 2.703 0 0 0 1.389 3.893 18.352 18.352 0 0 0 12.848 0 2.703 2.703 0 0 0 1.389-3.893l-3.846-6.6a1.607 1.607 0 0 1-.218-.81v-2.43h.763a.964.964 0 1 0 0-1.928H4.487a.964.964 0 0 0 0 1.928h.001ZM7.18 4.95V2.516h3.639V4.95c0 .625.166 1.24.48 1.78l.793 1.36c-2.012.2-3.955.177-6.14-.078L6.7 6.73c.315-.54.48-1.155.48-1.78Z",
  fill: "#F9F9F9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "experiment_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgExperiment;